import {
    createContext,
    useContext,
    useMemo,
} from 'react';
import { useQuery } from '@tanstack/react-query';

import { fetchWhatsappUnreadConversationCount } from './api';

interface ChatUnreadContextValue {
    totalUnread: number;
}

const ChatUnreadContext = createContext<ChatUnreadContextValue | undefined>(undefined);

export function ChatUnreadProvider({ children }: { children: React.ReactNode }) {
    const { data } = useQuery({
        queryKey: ['whatsapp-unread-count'],
        queryFn: fetchWhatsappUnreadConversationCount,
        refetchInterval: 30000,
    });

    const value = useMemo(() => ({ totalUnread: data ?? 0 }), [data]);

    return (
        <ChatUnreadContext.Provider value={value}>
            {children}
        </ChatUnreadContext.Provider>
    );
}

export function useChatUnread() {
    const ctx = useContext(ChatUnreadContext);
    if (!ctx) throw new Error('useChatUnread must be used within ChatUnreadProvider');
    return ctx;
}
